import React from "react";
import { Textarea } from "@/components/ui/textarea";

export const ReviewSubmitStep = ({ formData, onChange }) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Review & Submit</h2>
      <p className="text-gray-500 text-sm">Almost done! Add any final notes and review your submission.</p>
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">Anything else we should know?</label>
      <Textarea value={formData.additional_info} onChange={(e) => onChange("additional_info", e.target.value)} placeholder="Any other details, timelines, or specific requirements..." rows={3} className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-additional-info" />
    </div>

    <div className="bg-white/5 border border-white/10 rounded-xl p-5 space-y-3" data-testid="submission-summary">
      <h3 className="text-white font-medium text-sm">Submission Summary</h3>
      <div className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 text-sm">
        <span className="text-gray-500">Contact</span>
        <span className="text-gray-300">{formData.contact_name || "—"} ({formData.contact_email || "—"})</span>
        <span className="text-gray-500">Business</span>
        <span className="text-gray-300">{formData.business_name || "—"} — {formData.industry || "—"}</span>
        <span className="text-gray-500">Revenue</span>
        <span className="text-gray-300">{formData.revenue_range || "—"}</span>
        <span className="text-gray-500">Goals</span>
        <span className="text-gray-300 truncate">{formData.business_goals || "—"}</span>
        <span className="text-gray-500">Website</span>
        <span className="text-gray-300">{formData.website_platform || "—"}</span>
        <span className="text-gray-500">CRM</span>
        <span className="text-gray-300">{formData.crm_system || "—"}</span>
        <span className="text-gray-500">Social Media</span>
        <span className="text-gray-300 truncate">{formData.social_media_management || "—"}</span>
        <span className="text-gray-500">Content Production</span>
        <span className="text-gray-300 truncate">{formData.content_creation || "—"}</span>
        <span className="text-gray-500">Referral</span>
        <span className="text-gray-300">{formData.referral_source || "—"}</span>
      </div>
    </div>
  </div>
);
